import {GetterTree} from 'vuex'
import {WidgetState} from "../models/store-viewmodel"
import {Config} from "../models/config-viewmodel";

export default <GetterTree<WidgetState, WidgetState>>{
    innerLoading(state): boolean {
        return state.inner_loading
    },
    config(state): Config {
        return state.config
    },
    checkIfFavorite(state): boolean {
        return state.is_favorite
    },
    favoriteId(state): number|null {
        return state.favorite_id
    }
    
}
